import { Injectable } from '@angular/core';
import { LocalizationService } from '@services/localization.service';
import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { translatumApiUrl } from '@app/constants/projectLangCodeList';
import { environment } from '@environments/environment';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import localeTr from '@angular/common/locales/tr';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeFa from '@angular/common/locales/fa';
import localeAr from '@angular/common/locales/ar-IQ';
import localeVi from '@angular/common/locales/vi';
import localePl from '@angular/common/locales/pl';
import localeRu from '@angular/common/locales/ru';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeEl from '@angular/common/locales/el';
import localeBg from '@angular/common/locales/bg';
import localeDa from '@angular/common/locales/da';
import localeSr from '@angular/common/locales/sr';

import localeSq from '@angular/common/locales/sq';
import localeRo from '@angular/common/locales/ro';
import localePt from '@angular/common/locales/pt';
import localeNl from '@angular/common/locales/nl';
import localeMk from '@angular/common/locales/mk';
import localeIt from '@angular/common/locales/it';
@Injectable()
export class localizationInit {
  public LANGCODE = 'en';

  constructor(private _Localization: LocalizationService) {
    this.LANGCODE = this._Localization.LANGCODE;
    //// console.log("this._Localization.LANGID", this._Localization.LANGID);
    if (this._Localization.LANGID == 2) {
      registerLocaleData(localeEn);
    } else if (this._Localization.LANGID == 3) {
      registerLocaleData(localeTr);
    } else if (this._Localization.LANGID == 6) {
      registerLocaleData(localeDe);
    } else if (this._Localization.LANGID == 8) {
      registerLocaleData(localeFa);
      // jalaali.loadPersian({ usePersianDigits: true });
    } else if (this._Localization.LANGID == 10) {
      //// console.log("Locale registered.");
      registerLocaleData(localeAr);
      this.LANGCODE = 'ar-IQ';
    } else if (this._Localization.LANGID == 4) {
      registerLocaleData(localeAr);
      this.LANGCODE = 'ar-IQ';
    } else if (this._Localization.LANGID == 13) {
      registerLocaleData(localeVi);
      this.LANGCODE = 'vi';
    } else if (this._Localization.LANGID == 5) {
      registerLocaleData(localeRu);
      // jalaali.loadPersian({ usePersianDigits: true });
    } else if (this._Localization.LANGID == 12) {
      registerLocaleData(localePl);
      this.LANGCODE = 'pl';
      //// console.log('pl register');
    } else if (this._Localization.LANGID == 14) {
      registerLocaleData(localeFr);
      this.LANGCODE = 'fr';
    } else if (this._Localization.LANGID == 15) {
      registerLocaleData(localeEl);
      this.LANGCODE = 'el';
    } else if (this._Localization.LANGID == 7) {
      registerLocaleData(localeEs);
      this.LANGCODE = 'es';
    } else if (this._Localization.LANGID == 17) {
      registerLocaleData(localeBg);
      this.LANGCODE = 'bg';
    } else if (this._Localization.LANGID == 19) {
      registerLocaleData(localeDa);
      this.LANGCODE = 'da';
    } else if (this._Localization.LANGID == 20) {
      registerLocaleData(localeSr);
      this.LANGCODE = 'sr';
    } else if (this._Localization.LANGID == 11) {
      registerLocaleData(localePt);
      this.LANGCODE = 'pt';
    } else if (this._Localization.LANGID == 18) {
      registerLocaleData(localeRo);
      this.LANGCODE = 'ro';
    } else if (this._Localization.LANGID == 16) {
      registerLocaleData(localeSq);
      this.LANGCODE = 'sq';
    } else if (this._Localization.LANGID == 21) {
      registerLocaleData(localeNl);
      this.LANGCODE = 'nl';
    } else if (this._Localization.LANGID == 22) {
      registerLocaleData(localeIt);
      this.LANGCODE = 'it';
    } else if (this._Localization.LANGID == 23) {
      registerLocaleData(localeMk);
      this.LANGCODE = 'mk';
    } else {
      registerLocaleData(localeEn);
    }
  }

  getLanguage(): string {
    return this.LANGCODE;
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `${translatumApiUrl}${environment.product}/`, '.json');
  // https://translatum-bucket.s3.eu-central-1.amazonaws.com/prod/website/p1000/en.json
}

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return '-';
  }
}
